import { FC } from "react";
import { Button } from "antd";

interface SubmitEditButtonProps {
  onClick: () => void;
  updatingStatus: boolean;
  disabled: boolean;
}

const ApproveButton: FC<SubmitEditButtonProps> = ({
  onClick,
  updatingStatus,
  disabled
}) => (
  <Button
    type="primary"
    size="large"
    onClick={onClick}
    loading={updatingStatus}
    disabled={disabled}
  >
    Approve and publish
  </Button>
);

export default ApproveButton;
